
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onlyfans-restricted-words-checker",
      function () {
        return require("private-next-pages/onlyfans-restricted-words-checker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onlyfans-restricted-words-checker"])
      });
    }
  